import React from 'react'

function PharmacistLayout() {
  return (
    <div>PharmacistLayout</div>
  )
}

export default PharmacistLayout